import { Loader } from "@mantine/core";
import * as React from "react";

interface ScanBarProps {
  disabled: boolean;
  scanning: boolean;
  onScan: (serial: string) => void;
}


/**
 * Ô quét mã vạch. Input không kiểm soát (đọc giá trị khi Enter) nên máy quét gõ từng ký tự
 * không làm render lại cả trang như trang cũ.
 */
const ScanBar = ({ disabled, scanning, onScan }: ScanBarProps) => (
  <label
    style={{
      width: 260,
      height: 38,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "0 10px",
      border: `2px solid ${disabled ? "#DDE0DA" : "#1F5FAE"}`,
      borderRadius: 8,
      boxShadow: disabled ? "none" : "0 0 0 3px #E3ECF7",
      background: disabled ? "#F6F7F4" : "#FFFFFF",
      cursor: disabled ? "not-allowed" : "text",
      flexShrink: 0,
    }}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={disabled ? "#A3AAB2" : "#1F5FAE"}
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path d="M4 6v12M7 6v12M11 6v12M14 6v12M18 6v12M20 6v12" />
    </svg>
    <input
      type="text"
      aria-label="Nhập mã vạch"
      placeholder="Nhập mã vạch"
      autoComplete="off"
      spellCheck={false}
      disabled={disabled}
      aria-busy={scanning}
      style={{
        flexGrow: 1,
        minWidth: 0,
        border: 0,
        outline: "none",
        padding: 0,
        fontFamily: "inherit",
        fontSize: 13,
        textTransform: "uppercase",
        color: "#1B1F24",
        background: "transparent",
        cursor: "inherit",
      }}
      onKeyDown={(e) => {
        if (e.key === " ") {
          e.preventDefault();
          return;
        }
        if (e.key === "Enter") {
          const value = e.currentTarget.value.trim();
          if (!value) return;
          e.currentTarget.value = "";
          onScan(value);
        }
      }}
    />
    {scanning && <Loader size={14} color="#1F5FAE" />}
  </label>
);

export default React.memo(ScanBar);
